import { ref, Ref, onMounted } from 'vue';

import { Pokemon, Move, Type } from '../types';
import { fetchResource } from './resource';

export function useData(): {
  pokemons: Ref<Pokemon[]>;
  moves: Ref<Move[]>;
  types: Ref<Type[]>;
  getTypeByName: (name: string) => Type;
} {
  const pokemons = ref<Pokemon[]>([]);
  const moves = ref<Move[]>([]);
  const types = ref<Type[]>([]);

  const getTypeByName = (name: string): Type => {
    return types.value.find((type) => name === type.name) || { id: '', name: '', iconURL: '' };
  };

  onMounted(async () => {
    const res = (await fetchResource()) || { pokemons: [], moves: [], types: [] };
    pokemons.value = res.pokemons;
    moves.value = res.moves;
    types.value = res.types;
  });

  return {
    pokemons,
    moves,
    types,
    getTypeByName,
  };
}
